import React from 'react';

import { Box, Collapse, Stack, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { Outlet, useMatch, useNavigate } from 'react-router-dom';
import { AppContext } from '../../../contexts/app_context';
import { createScopedI18n } from '../../../i18n/i18n';
import Protector from '../../../components/protector';

const jobCreatePageI18n = createScopedI18n('pages.jobs_new');

const JobCreateLayout = () => {
  const navigate = useNavigate();
  const matchPeriodJobsNewPage = useMatch('/jobs/period_jobs/new');
  const { contextCurrentRestaurant } = React.useContext(AppContext);

  return (
    <>
      <Box display="flex" flex={1} flexDirection="column" overflow="auto">
        <Protector permissions={['periodJobCreate']}>
          <Protector.Allowed>
            <Stack
              display={contextCurrentRestaurant ? 'flex' : 'none'}
              direction="row"
              justifyContent="center"
              padding={1}
              paddingTop={2}
            >
              <ToggleButtonGroup size="small" color="primary" value={matchPeriodJobsNewPage ? 'PERIOD' : 'NORMAL'}>
                <ToggleButton
                  value="NORMAL"
                  onClick={() => navigate('/jobs/new', { replace: true })}
                  sx={{ paddingX: 3 }}
                >
                  {jobCreatePageI18n('create_normal_job_title')}
                </ToggleButton>
                <ToggleButton
                  value="PERIOD"
                  onClick={() => navigate('/jobs/period_jobs/new', { replace: true })}
                  sx={{ paddingX: 3 }}
                >
                  {jobCreatePageI18n('create_period_job_title')}
                </ToggleButton>
              </ToggleButtonGroup>
            </Stack>
          </Protector.Allowed>
        </Protector>

        <Outlet />
      </Box>
    </>
  );
};

export default JobCreateLayout;
